/* WIG theme interactions — market selector (Shopify localization) */
(function () {
  'use strict';

  const WIG_MARKET_KEY = 'wig_market_country';
  const WIG_MARKET_LABELS = { US: 'United States', FR: 'France' };

  const readWigMarket = () => {
    try {
      const saved = localStorage.getItem(WIG_MARKET_KEY);
      if (saved === 'FR' || saved === 'US') return saved;
    } catch (error) {
      /* ignore storage errors */
    }
    return 'US';
  };

  const writeWigMarket = (country) => {
    try {
      localStorage.setItem(WIG_MARKET_KEY, country);
    } catch (error) {
      /* ignore storage errors */
    }
  };

  const getWigFlagHtml = (country) => {
    const store = document.getElementById('wig-market-flag-templates');
    if (!store) return '';
    const node = store.querySelector(`[data-wig-flag-html="${country}"]`);
    return node ? node.innerHTML.trim() : '';
  };

  const updateMarketSelectorUI = (root, country) => {
    const trigger = root.querySelector('[data-wig-market-trigger]');
    const triggerFlag = root.querySelector('[data-wig-market-trigger-flag]');
    const triggerCode = root.querySelector('.wig-market-selector__trigger .wig-market-selector__code');

    root.dataset.wigMarketCurrent = country;

    if (triggerCode) triggerCode.textContent = country;
    if (trigger) {
      trigger.setAttribute(
        'aria-label',
        `Shipping country: ${WIG_MARKET_LABELS[country]}. Click to change.`
      );
    }
    if (triggerFlag) {
      const html = getWigFlagHtml(country);
      if (html) triggerFlag.innerHTML = html;
    }

    root.querySelectorAll('[data-wig-market-option]').forEach((option) => {
      const isCurrent = option.dataset.countryCode === country;
      option.classList.toggle('is-current', isCurrent);
      option.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
    });
  };

  const applyWigMarket = (country) => {
    if (country !== 'FR' && country !== 'US') return;

    document.documentElement.dataset.wigMarket = country;

    document.querySelectorAll('[data-wig-market-copy]').forEach((node) => {
      const text = country === 'FR' ? node.dataset.marketFr : node.dataset.marketUs;
      if (text != null) node.textContent = text;
    });

    document.querySelectorAll('[data-wig-market-placeholder]').forEach((node) => {
      const text = country === 'FR' ? node.dataset.marketFr : node.dataset.marketUs;
      if (text != null) node.placeholder = text;
    });

    document.querySelectorAll('[data-wig-market-select]').forEach((node) => {
      if (node.value !== country) {
        node.value = country;
        node.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    document.querySelectorAll('[data-wig-market-selector]').forEach((root) => {
      updateMarketSelectorUI(root, country);
    });
  };

  const setWigMarket = (country) => {
    if (country !== 'FR' && country !== 'US') return;
    writeWigMarket(country);
    applyWigMarket(country);
  };

  window.__wigSetMarket = setWigMarket;
  window.__wigApplyMarket = applyWigMarket;

  /* Shopify preview iframe covers the viewport; clicks must pass through to the storefront */
  const passThroughPreviewBar = () => {
    ['PBarNextFrameWrapper', 'PBarNextFrame', 'preview-bar-iframe'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.setProperty('pointer-events', 'none', 'important');
    });
  };

  /* Mobile WebViews (Safari / WeChat): contain horizontal overflow without blocking vertical scroll */
  const MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  const fixMobileLayout = () => {
    passThroughPreviewBar();
    if (!document.body.classList.contains('wig-page') || !MOBILE_MQ.matches) return;

    document.documentElement.classList.add('wig-html');

    const vw = document.documentElement.clientWidth || window.innerWidth;
    const pbar = document.getElementById('PBarNextFrameWrapper');
    const pbarFrame = document.getElementById('PBarNextFrame');
    if (pbar) {
      pbar.style.maxWidth = `${vw}px`;
      pbar.style.width = '100%';
    }
    if (pbarFrame) {
      pbarFrame.style.maxWidth = '100%';
    }

    if (window.scrollX !== 0) {
      window.scrollTo(0, window.scrollY);
    }
  };

  passThroughPreviewBar();
  fixMobileLayout();
  document.addEventListener('DOMContentLoaded', fixMobileLayout, { passive: true });
  window.addEventListener('load', fixMobileLayout, { passive: true });
  MOBILE_MQ.addEventListener('change', fixMobileLayout, { passive: true });
  window.addEventListener('orientationchange', fixMobileLayout, { passive: true });

  if (typeof MutationObserver !== 'undefined') {
    let fixTimer;
    const scheduleFix = () => {
      clearTimeout(fixTimer);
      fixTimer = setTimeout(fixMobileLayout, 80);
    };
    const previewObserver = new MutationObserver(scheduleFix);
    previewObserver.observe(document.documentElement, { childList: true, subtree: false });
    if (document.body) previewObserver.observe(document.body, { childList: true, subtree: false });
  }

  /* Shared add-to-cart helpers (homepage spotlight, recs, etc.) */
  const WigCart = {
    getSectionIds() {
      const wevoltId = document.querySelector('[data-wevolt-cart-drawer]')?.dataset.sectionId;
      return wevoltId ? [wevoltId] : [];
    },

    updateSections(sectionsHtml) {
      if (!sectionsHtml) return Promise.resolve();
      const wevoltId = document.querySelector('[data-wevolt-cart-drawer]')?.dataset.sectionId;
      if (wevoltId && sectionsHtml[wevoltId] && window.wevoltCartDrawer?.applySections) {
        return window.wevoltCartDrawer.applySections(sectionsHtml, wevoltId);
      }
      return Promise.resolve();
    },

    updateBadge(itemCount) {
      if (itemCount == null) return;
      document.querySelectorAll('.wig-header__cart-count').forEach((el) => {
        el.textContent = String(itemCount);
        el.classList.toggle('is-empty', itemCount === 0);
      });
    },

    readCountFromDrawer() {
      const el = document.querySelector('[data-wevolt-cart-count]');
      if (!el) return null;
      const raw = el.getAttribute('data-wevolt-cart-count') || el.textContent;
      const count = parseInt(raw, 10);
      return Number.isNaN(count) ? null : count;
    },

    async resolveCartCount(data) {
      if (data?.item_count != null) return data.item_count;
      const fromDrawer = this.readCountFromDrawer();
      if (fromDrawer != null) return fromDrawer;
      try {
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        return cart.item_count;
      } catch {
        return data?.items?.reduce((sum, item) => sum + (item.quantity || 0), 0) ?? null;
      }
    },

    openDrawer(detail = {}) {
      document.dispatchEvent(new CustomEvent('wevolt:cart:open', { bubbles: true, detail }));
    },

    dispatchUpdate(data) {
      const itemCount = data?.item_count ?? null;
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            data: { itemCount, sections: data?.sections, source: 'wig-cart' },
          },
        })
      );
      document.dispatchEvent(
        new CustomEvent('wevolt:cart:updated', { detail: { itemCount, sections: data?.sections } })
      );
      this.updateBadge(itemCount);
      if (itemCount != null && window.wevoltCartDrawer?.updateBubbles) {
        window.wevoltCartDrawer.updateBubbles(itemCount);
      }
    },

    async addVariant(variantId, quantity = 1) {
      const sectionIds = this.getSectionIds();
      const items = [{ id: Number(variantId), quantity }];
      const withSections = sectionIds.length ? { items, sections: sectionIds.join(',') } : { items };

      let response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(withSections),
      });
      let data = await response.json();

      if ((!response.ok || data.status) && sectionIds.length) {
        response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        data = await response.json();
      }

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add to cart');
      }

      await this.updateSections(data.sections);
      data.item_count = await this.resolveCartCount(data);
      this.dispatchUpdate(data);
      this.openDrawer({ itemCount: data.item_count, sections: data.sections });
      return data;
    },
  };

  window.WigCart = WigCart;

  /* Header scroll + mobile menu */
  const header = document.querySelector('.wig-header');
  const menuBtn = document.querySelector('.wig-header__menu-btn');
  const mobileNav = document.querySelector('.wig-header__mobile-nav');
  const mobileNavBackdrop = document.querySelector('.wig-header__mobile-nav-backdrop');

  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  const syncMobileNavTop = () => {
    if (!header || !mobileNav) return;
    const top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    mobileNav.style.setProperty('--wig-mobile-nav-top', `${top}px`);
    mobileNavBackdrop?.style.setProperty('--wig-mobile-nav-top', `${top}px`);
  };

  const mountMobileNav = () => {
    if (!mobileNav || mobileNav.dataset.portaled === 'true') return;
    if (mobileNavBackdrop) document.body.appendChild(mobileNavBackdrop);
    document.body.appendChild(mobileNav);
    mobileNav.dataset.portaled = 'true';
  };

  mountMobileNav();

  if (menuBtn && mobileNav) {
    const closeBtn = mobileNav.querySelector('.wig-header__mobile-nav-close');

    const setMobileNavOpen = (open) => {
      if (open) syncMobileNavTop();
      mobileNav.classList.toggle('is-open', open);
      mobileNav.hidden = !open;
      mobileNavBackdrop?.classList.toggle('is-open', open);
      if (mobileNavBackdrop) mobileNavBackdrop.hidden = !open;
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('wevolt-scroll-lock', open);
      document.documentElement.classList.toggle('wig-menu-open', open);
    };

    menuBtn.addEventListener('click', () => {
      setMobileNavOpen(!mobileNav.classList.contains('is-open'));
    });

    closeBtn?.addEventListener('click', () => setMobileNavOpen(false));
    mobileNavBackdrop?.addEventListener('click', () => setMobileNavOpen(false));
    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMobileNavOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        setMobileNavOpen(false);
      }
    });

    window.addEventListener('resize', () => {
      if (mobileNav.classList.contains('is-open')) syncMobileNavTop();
    }, { passive: true });

    document.addEventListener('shopify:section:load', (event) => {
      if (!event.target.querySelector?.('.wig-header')) return;
      const nextNav = event.target.querySelector('.wig-header__mobile-nav');
      const nextBackdrop = event.target.querySelector('.wig-header__mobile-nav-backdrop');
      if (nextNav && nextNav.dataset.portaled !== 'true') {
        if (nextBackdrop) document.body.appendChild(nextBackdrop);
        document.body.appendChild(nextNav);
        nextNav.dataset.portaled = 'true';
      }
    });
  }

  const closeMarketMenus = (except) => {
    document.querySelectorAll('[data-wig-market-selector]').forEach((root) => {
      if (except && root === except) return;
      const trigger = root.querySelector('[data-wig-market-trigger]');
      const menu = root.querySelector('[data-wig-market-menu]');
      if (!trigger || !menu) return;
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    });
  };

  const bindMarketSelector = (root) => {
    if (!root || root.dataset.marketBound === 'true') return;
    const trigger = root.querySelector('[data-wig-market-trigger]');
    const menu = root.querySelector('[data-wig-market-menu]');
    const form = root.querySelector('form') || root.closest('form');
    if (!trigger || !menu) return;

    root.dataset.marketBound = 'true';

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeMarketMenus(root);
      const nextOpen = !isOpen;
      trigger.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
      menu.hidden = !nextOpen;
    });

    if (form && form.dataset.wigMarketSubmitBound !== 'true') {
      form.dataset.wigMarketSubmitBound = 'true';
      form.addEventListener('submit', () => {
        form.querySelectorAll('input[name="return_to"]').forEach((input) => input.remove());
        root.classList.add('is-switching');
      });
    }

    root.querySelectorAll('[data-wig-market-option], .wig-market-selector__option').forEach((option) => {
      option.addEventListener('click', (event) => {
        event.stopPropagation();

        const country =
          option.dataset.countryCode || option.value || option.getAttribute('value');
        if (country !== 'FR' && country !== 'US') {
          event.preventDefault();
          return;
        }

        writeWigMarket(country);

        const submitForm = option.closest('form') || form;
        const countryInput = submitForm && submitForm.querySelector('[data-wig-market-country-input]');
        const localeInput = submitForm && submitForm.querySelector('[data-wig-market-locale-input]');
        if (!submitForm || !countryInput) {
          event.preventDefault();
          setWigMarket(country);
          closeMarketMenus();
          return;
        }

        countryInput.value = country;
        if (localeInput) {
          localeInput.value = option.dataset.localeCode || (country === 'FR' ? 'fr' : 'en');
        }
        submitForm.querySelectorAll('input[name="return_to"]').forEach((input) => input.remove());
        root.classList.add('is-switching');
      });
    });
  };

  const initMarketSelectors = (scope = document) => {
    scope.querySelectorAll('[data-wig-market-selector]').forEach(bindMarketSelector);
  };

  initMarketSelectors();
  const shopMarket = document.querySelector('[data-wig-market-selector]')?.dataset.wigMarketCurrent;
  const initialMarket = shopMarket === 'FR' || shopMarket === 'US' ? shopMarket : readWigMarket();
  writeWigMarket(initialMarket);
  applyWigMarket(initialMarket);

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-wig-market-selector]')) {
      closeMarketMenus();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMarketMenus();
  });

  const openWigCartDrawer = () => {
    if (window.wevoltCartDrawer) {
      window.wevoltCartDrawer.open();
      return;
    }

    document.querySelector('cart-drawer-component')?.open?.();
  };

  document.querySelector('[data-wig-cart-open]')?.addEventListener('click', (event) => {
    event.preventDefault();
    openWigCartDrawer();
  });

  /* Membership accordion */
  const initMembershipAccordion = (root = document) => {
    root.querySelectorAll('.wig-membership:not([data-membership-ready])').forEach((section) => {
      section.dataset.membershipReady = 'true';
      const items = section.querySelectorAll('.wig-membership__item');

      items.forEach((item) => {
        const trigger = item.querySelector('.wig-membership__trigger');
        if (!trigger) return;

        trigger.addEventListener('click', () => {
          const isActive = item.classList.contains('is-active');
          items.forEach((i) => i.classList.remove('is-active'));

          if (!isActive) {
            item.classList.add('is-active');
          } else if (items[0]) {
            items[0].classList.add('is-active');
          }
        });
      });

      if (items[0]) items[0].classList.add('is-active');
    });
  };

  initMembershipAccordion();

  document.addEventListener('shopify:section:load', (event) => {
    initMembershipAccordion(event.target);
    initMarketSelectors(event.target);
    if (event.target.querySelector?.('.wig-header__mobile-nav')) {
      mountMobileNav();
    }
  });

  /* Lifestyle tabs */
  document.querySelectorAll('.wig-lifestyle').forEach((section) => {
    const tabs = section.querySelectorAll('.wig-lifestyle__tab');
    const panels = section.querySelectorAll('.wig-lifestyle__panel');

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => t.classList.remove('is-active'));
        panels.forEach((p) => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        if (panels[index]) panels[index].classList.add('is-active');
      });
    });
  });

  /* News carousel */
  document.querySelectorAll('.wig-news').forEach((section) => {
    const track = section.querySelector('.wig-news__track');
    const prev = section.querySelector('.wig-news__prev');
    const next = section.querySelector('.wig-news__next');
    if (!track) return;

    const scroll = (dir) => {
      const card = track.querySelector('.wig-news__card');
      const amount = card ? card.offsetWidth + 16 : 400;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    if (prev) prev.addEventListener('click', () => scroll(-1));
    if (next) next.addEventListener('click', () => scroll(1));

    const updateButtons = () => {
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    };

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  });

  /* Homepage / spotlight gallery — manual thumb carousel (no autoplay) */
  const initSpotlightGalleries = (root = document) => {
    root.querySelectorAll('[data-spotlight-gallery]').forEach((gallery) => {
      if (gallery.dataset.spotlightReady === 'true') return;
      if (gallery.classList.contains('wig-pdp__gallery')) return;

    const hero = gallery.querySelector('[data-spotlight-main]');
    const track = gallery.querySelector('[data-pdp-thumbs-track]');
    if (!hero || !track) return;

    const thumbs = [...track.querySelectorAll('.wig-spotlight__thumb')];
    if (!thumbs.length) return;

    const sectionId = gallery.dataset.sectionId;
    let product = null;
    const productJson = document.querySelector(`[data-spotlight-product="${sectionId}"]`);
    if (productJson) {
      try {
        product = JSON.parse(productJson.textContent);
      } catch (e) {
        product = null;
      }
    }

    const carousel = gallery.querySelector('[data-pdp-thumbs-carousel]');
    const prevBtn = carousel?.querySelector('[data-pdp-thumbs-prev]');
    const nextBtn = carousel?.querySelector('[data-pdp-thumbs-next]');
    const mainId = thumbs[0].dataset.target;
    let thumbDragMoved = false;

    const scrollThumbIntoView = (thumb) => {
      if (!thumb) return;
      const thumbLeft = thumb.offsetLeft;
      const thumbRight = thumbLeft + thumb.offsetWidth;
      const viewLeft = track.scrollLeft;
      const viewRight = viewLeft + track.clientWidth;
      if (thumbLeft < viewLeft) {
        track.scrollTo({ left: thumbLeft, behavior: 'smooth' });
      } else if (thumbRight > viewRight) {
        track.scrollTo({ left: thumbRight - track.clientWidth, behavior: 'smooth' });
      }
    };

    const updateNavButtons = () => {
      if (!prevBtn || !nextBtn) return;
      const overflow = track.scrollWidth > track.clientWidth + 4;
      prevBtn.classList.toggle('is-hidden', !overflow);
      nextBtn.classList.toggle('is-hidden', !overflow);
      if (!overflow) return;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };

    const scrollThumbs = (dir) => {
      const thumb = track.querySelector('.wig-spotlight__thumb');
      const gap = 10;
      const amount = thumb ? thumb.offsetWidth + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    };

    prevBtn?.addEventListener('click', () => scrollThumbs(-1));
    nextBtn?.addEventListener('click', () => scrollThumbs(1));
    track.addEventListener('scroll', updateNavButtons, { passive: true });
    window.addEventListener('resize', updateNavButtons);
    updateNavButtons();

    const setActiveThumb = (index) => {
      thumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      scrollThumbIntoView(thumbs[index]);
      window.setTimeout(updateNavButtons, 320);
    };

    const renderImage = (src, alt) => {
      hero.innerHTML = '';
      const img = document.createElement('img');
      if (mainId) img.id = mainId;
      img.src = src;
      img.alt = alt || '';
      img.loading = 'eager';
      img.dataset.spotlightImage = '';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      img.style.display = 'block';
      hero.appendChild(img);
    };

    const playSpotlightVideo = (video) => {
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      const attempt = () => {
        video.play().catch(() => {});
      };
      if (video.readyState >= 2) attempt();
      else video.addEventListener('loadeddata', attempt, { once: true });
    };

    const renderVideo = (media, thumb) => {
      const sources = (media?.sources || []).filter((s) => s.mime_type?.includes('video'));
      const fallbackSrc = thumb?.dataset.videoSrc || '';
      const poster = media?.preview_image?.src || media?.preview_image || thumb?.querySelector('img')?.src || '';
      hero.innerHTML = '';
      const wrap = document.createElement('div');
      wrap.className = 'wig-pdp__video-wrap wig-pdp__video-wrap--916';
      wrap.dataset.videoAspect = '9:16';
      const video = document.createElement('video');
      video.className = 'wig-pdp__hero-video wig-pdp__hero-video--916';
      video.controls = true;
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      video.preload = 'auto';
      if (poster) video.poster = typeof poster === 'string' ? poster : poster.src;
      if (sources.length) {
        sources.forEach((source) => {
          const el = document.createElement('source');
          el.src = source.url;
          el.type = source.mime_type;
          video.appendChild(el);
        });
      } else if (fallbackSrc) {
        video.src = fallbackSrc;
      } else if (media?.sources?.[0]?.url) {
        video.src = media.sources[0].url;
      }
      wrap.appendChild(video);
      hero.appendChild(wrap);
      video.load();
      playSpotlightVideo(video);
    };

    const showMedia = (index) => {
      const thumb = thumbs[index];
      if (!thumb) return;
      setActiveThumb(index);

      const isVideo = thumb.dataset.mediaType === 'video';
      const mediaId = thumb.dataset.mediaId ? Number(thumb.dataset.mediaId) : null;
      const media = mediaId && product?.media
        ? product.media.find((item) => String(item.id) === String(mediaId))
        : null;

      if (isVideo) {
        renderVideo(media || { sources: [{ url: thumb.dataset.videoSrc, mime_type: 'video/mp4' }] }, thumb);
        return;
      }

      const src = thumb.dataset.src;
      if (src) renderImage(src, product?.title || '');
    };

    const drag = { active: false, moved: false, startX: 0, scrollLeft: 0, pointerId: null };

    track.addEventListener('pointerdown', (event) => {
      drag.active = true;
      drag.moved = false;
      thumbDragMoved = false;
      drag.startX = event.clientX;
      drag.scrollLeft = track.scrollLeft;
      drag.pointerId = event.pointerId;
    });

    track.addEventListener('pointermove', (event) => {
      if (!drag.active || event.pointerId !== drag.pointerId) return;
      const deltaX = event.clientX - drag.startX;
      if (!drag.moved && Math.abs(deltaX) > 6) {
        drag.moved = true;
        thumbDragMoved = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
      }
      if (drag.moved) {
        event.preventDefault();
        track.scrollLeft = drag.scrollLeft - deltaX;
      }
    });

    const endDrag = (event) => {
      if (!drag.active || event.pointerId !== drag.pointerId) return;
      drag.active = false;
      track.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      updateNavButtons();
      if (thumbDragMoved) {
        window.setTimeout(() => {
          thumbDragMoved = false;
        }, 0);
      }
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', (event) => {
        if (thumbDragMoved) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        showMedia(index);
      });

      thumb.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          showMedia(index);
        }
      });
    });

    const activeIndex = thumbs.findIndex((t) => t.classList.contains('is-active'));
    if (activeIndex >= 0) {
      const activeThumb = thumbs[activeIndex];
      const existingVideo = hero.querySelector('video');
      if (activeThumb.dataset.mediaType === 'video') {
        if (existingVideo) {
          playSpotlightVideo(existingVideo);
        } else {
          showMedia(activeIndex);
        }
      }
      scrollThumbIntoView(activeThumb);
    }

    hero.querySelectorAll('video').forEach((video) => playSpotlightVideo(video));

    updateNavButtons();
    gallery.dataset.spotlightReady = 'true';
    });
  };

  initSpotlightGalleries();

  document.addEventListener('shopify:section:load', (event) => {
    initSpotlightGalleries(event.target);
    initSpotlightVariants(event.target);
  });

  const isVariantAvailable = (variant) => {
    if (!variant) return false;
    const value = variant.available;
    if (value === false || value === 'false' || value === 0 || value === '0') return false;
    return true;
  };

  const formatSpotlightMoney = (cents, moneyFormat) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat || window.theme?.moneyFormat || window.Shopify.currency?.active);
    }
    const currency = window.Shopify?.currency?.active || 'USD';
    const amount = (Number(cents) / 100).toFixed(2);
    if (currency === 'EUR') return `€${amount}`;
    return `$${amount}`;
  };

  const initSpotlightVariants = (root = document) => {
    root.querySelectorAll('.wig-spotlight__form').forEach((form) => {
      if (form.dataset.spotlightVariantsReady === 'true') return;
      form.dataset.spotlightVariantsReady = 'true';

      const section = form.closest('.wig-spotlight');
      if (!section) return;

      const sectionId = section.querySelector('[data-spotlight-gallery]')?.dataset.sectionId;
      const productJson = sectionId ? document.querySelector(`[data-spotlight-product="${sectionId}"]`) : null;
      let variants = [];
      let moneyFormat = window.theme?.moneyFormat;
      if (productJson) {
        try {
          const data = JSON.parse(productJson.textContent);
          variants = data.variants || data.product?.variants || [];
          if (typeof data === 'object' && data.id && Array.isArray(data.variants)) {
            variants = data.variants;
          }
          if (data.money_format) moneyFormat = data.money_format;
        } catch (e) {
          variants = [];
        }
      }

      const priceEl = section.querySelector('[data-spotlight-price]');
      const compareEl = section.querySelector('[data-spotlight-compare]');
      const atcEl = section.querySelector('[data-spotlight-atc]');

      const syncVariant = (variantId) => {
        if (!variants.length) return;
        const variant = variants.find((v) => String(v.id) === String(variantId));
        if (!variant) return;

        const price = Number(variant.price);
        const compareAt = Number(variant.compare_at_price || 0);
        const compareOverride = section.dataset.compareOverride?.trim();
        const serverAvailable = atcEl?.getAttribute('data-server-available') !== 'false';

        if (priceEl) priceEl.textContent = formatSpotlightMoney(price, moneyFormat);
        if (compareEl) {
          if (compareOverride) {
            compareEl.textContent = compareOverride;
            compareEl.hidden = false;
          } else if (compareAt > price) {
            compareEl.textContent = formatSpotlightMoney(compareAt, moneyFormat);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (atcEl) {
          const available = isVariantAvailable(variant);
          if (available) {
            atcEl.disabled = false;
            atcEl.textContent = `ADD TO BAG — ${formatSpotlightMoney(price, moneyFormat)}`;
            atcEl.classList.remove('is-sold-out');
            atcEl.setAttribute('data-server-available', 'true');
          } else {
            const fallback = variants.find((item) => isVariantAvailable(item));
            const fallbackInput = fallback
              ? form.querySelector(`.wig-spotlight__color input[name="id"][value="${fallback.id}"]`)
              : null;
            if (fallbackInput && !fallbackInput.disabled) {
              fallbackInput.checked = true;
              onVariantPick(fallbackInput);
              return;
            }
            atcEl.disabled = true;
            atcEl.textContent = 'Sold Out';
            atcEl.classList.add('is-sold-out');
            atcEl.setAttribute('data-server-available', 'false');
          }
        }
      };

      const pickDefaultVariant = () => {
        const inputs = [...form.querySelectorAll('.wig-spotlight__color input')];
        if (!inputs.length) {
          const hidden = form.querySelector('input[name="id"]');
          if (hidden) syncVariant(hidden.value);
          return;
        }

        let checked = inputs.find((input) => input.checked && !input.disabled);
        if (!checked) {
          checked = inputs.find((input) => {
            if (input.disabled) return false;
            const variant = variants.find((item) => String(item.id) === String(input.value));
            return isVariantAvailable(variant);
          });
        }
        if (!checked) {
          checked = inputs.find((input) => !input.disabled) || inputs[0];
        }
        if (checked) {
          checked.checked = true;
          checked.closest('.wig-spotlight__color')?.classList.add('is-active');
        }

        if (checked) syncVariant(checked.value);
      };

      const onVariantPick = (input) => {
        const list = input.closest('.wig-spotlight__colors-list');
        list?.querySelectorAll('.wig-spotlight__color').forEach((el) => el.classList.remove('is-active'));
        input.closest('.wig-spotlight__color')?.classList.add('is-active');
        syncVariant(input.value);
      };

      form.querySelectorAll('.wig-spotlight__color input').forEach((input) => {
        input.addEventListener('change', () => onVariantPick(input));
      });

      pickDefaultVariant();
    });
  };

  initSpotlightVariants();

  window.WigSpotlight = { initVariants: initSpotlightVariants };

  /* WIG Install Guide — step tabs */
  document.querySelectorAll('[data-install-guide]').forEach((section) => {
    const mainImg = section.querySelector('[data-install-main] .wig-pdp-install__main-img');
    const steps = [...section.querySelectorAll('[data-install-step]')];
    if (!steps.length) return;

    const activate = (index) => {
      steps.forEach((btn, i) => {
        const active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-current', active ? 'step' : 'false');
      });
      const btn = steps[index];
      const src = btn?.dataset.imageSrc;
      const alt = btn?.dataset.imageAlt;
      if (mainImg && src) {
        mainImg.src = src;
        if (alt) mainImg.alt = alt;
      }
    };

    steps.forEach((btn, index) => {
      btn.addEventListener('click', () => activate(index));
    });
  });

  /* PDP quantity controls (wig-pdp.js handles variants & sticky bar) */
  document.querySelectorAll('.wig-pdp__qty-control, .wig-pdp-buy__qty').forEach((wrap) => {
    const input = wrap.querySelector('.wig-pdp__qty-input, .wig-pdp-buy__qty-input');
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    minus?.addEventListener('click', () => {
      input.value = String(Math.max(1, Number(input.value || 1) - 1));
    });
    plus?.addEventListener('click', () => {
      input.value = String(Number(input.value || 1) + 1);
    });
  });

  /* PDP tabs */
  document.querySelectorAll('.wig-pdp-tabs').forEach((section) => {
    const tabs = section.querySelectorAll('.wig-pdp-tabs__tab');
    const panels = section.querySelectorAll('.wig-pdp-tabs__panel');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.tab;
        tabs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach((p) => {
          p.classList.remove('is-active');
          p.hidden = true;
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        const panel = section.querySelector(`[data-panel="${id}"]`);
        if (panel) {
          panel.classList.add('is-active');
          panel.hidden = false;
        }
      });
    });
  });

  /* PDP You May Also Like */
  const openWigCartDrawerFromRec = () => {
    if (window.wevoltCartDrawer) {
      window.wevoltCartDrawer.open();
      return;
    }

    document.querySelector('cart-drawer-component')?.open?.();
  };

  const bindPdpRecQuickAdd = (scope = document) => {
    scope.querySelectorAll('[data-wig-rec-add]:not([data-rec-bound])').forEach((button) => {
      button.dataset.recBound = 'true';
      button.addEventListener('click', async () => {
        const variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        button.disabled = true;
        const originalLabel = button.textContent;
        button.textContent = 'Adding…';

        try {
          const data = window.WigCart
            ? await window.WigCart.addVariant(variantId, 1)
            : await (async () => {
                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
                });
                const payload = await response.json();
                if (!response.ok || payload.status) {
                  throw new Error(payload.description || 'Could not add to cart');
                }
                return payload;
              })();

          button.textContent = 'Added ✓';
          if (!window.WigCart) openWigCartDrawerFromRec();
          window.setTimeout(() => {
            button.textContent = originalLabel;
            button.disabled = false;
          }, 1800);
        } catch (error) {
          button.textContent = originalLabel;
          button.disabled = false;
        }
      });
    });
  };

  const initPdpRecommendations = (root = document) => {
    bindPdpRecQuickAdd(root);

    root.querySelectorAll('[data-wig-pdp-recs][data-recs-source="shopify"]:not([data-recs-ready])').forEach((section) => {
      section.dataset.recsReady = 'true';
      const fetchUrl = section.dataset.recsUrl;
      const content = section.querySelector('[data-wig-pdp-recs-content]');
      if (!fetchUrl || !content) return;

      const loadRecommendations = () => {
        fetch(fetchUrl)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newContent = doc.querySelector('[data-wig-pdp-recs-content]');
            if (!newContent || !newContent.innerHTML.trim()) {
              section.hidden = true;
              return;
            }
            content.innerHTML = newContent.innerHTML;
            bindPdpRecQuickAdd(content);
          })
          .catch(() => {
            section.hidden = true;
          });
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries[0].isIntersecting) return;
          observer.disconnect();
          loadRecommendations();
        }, { rootMargin: '240px 0px' });
        observer.observe(section);
      } else {
        loadRecommendations();
      }
    });
  };

  initPdpRecommendations();

  document.addEventListener('shopify:section:load', (event) => {
    initPdpRecommendations(event.target);
  });
})();
